export class ApplicationRoutes {
	static readonly LANDING_PAGE = "/";
	static readonly RECOMMENDATION = "recommendation";
	static readonly RECOMMENDATION_FINALIZATION = "recommendation/finalize";
	static readonly RECOMMENDATION_OVERVIEW = "recommendation/overview";
	static readonly RECOMMENDATION_PRODUCTS = "recommendation/products";
	static readonly RECOMMENDATION_PRODUCT_DETAILS = "recommendation/products/:id";
	static readonly RECOMMENDATION_PRODUCT_CONFIRMATION = "recommendation/products/:id/confirmation";
	static readonly LOGIN = "login";
	static readonly FORGOT_PASSWORD = "forgot-password/:token";
	static readonly PAY_REQUEST = "pay-request/:token";
	static readonly GUEST_BILL_PAYMENT = "guest-bill-payment";
	static readonly GUEST_BILL_PAYMENT_DEEPLINK = "guest_bill_payment";

	static readonly TERMS = "terms";
	static readonly PRIVACY_POLICY = "privacy-policy";
	static readonly DELETE_INSTRUCTION = "delete-account-instruction";
	static readonly COMING_SOON = "coming-soon";
	static readonly FAQ = "/#got-questions-section";
	static readonly BENEFITS = "/#benefits";

	static readonly PRODUCTS = "products";

	static readonly PROVIDER_BASE = "provider";
	static readonly PROVIDER_SIGNUP = "provider/signup";
	static readonly PROVIDER_SIGNUP_CONFIRMATION = "registration/:code";
	static readonly PROVIDER_TEAM_MEMBER_CONFIRMATION = "provider/team-members/confirmation/:code";
	static readonly PROVIDER_CUSTOMERS = "customers";

	static readonly ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET_PATH ?? "";
	static readonly ADMIN_UTIL_SECRET = process.env.REACT_APP_UTILITY_ADMIN_SECRET_PATH ?? "";
	static readonly ADMIN_BASE = `${process.env.REACT_APP_ADMIN_SECRET_PATH ?? ""}/admin`.replace(/^\//, "");
	static readonly ADMIN_UTIL_BASE = `${process.env.REACT_APP_UTILITY_ADMIN_SECRET_PATH ?? ""}/util-admin`.replace(/^\//, "");
	static readonly PRODUCTS_CATEGORY = "products-category";
	static readonly ADVERT_BANNER = "store-banner";
	static readonly DEPARTMENT_CONFIGURATION = "department-configuration";
	static readonly CREATE_DEPARTMENT = "create-department";

	static readonly DASHBOARD = "dashboard";
	static readonly SOLAR_PROVIDER = "solar-provider";
	static readonly PROVIDER_COMPANY_FIRST_LOGIN = "first-login/";
	static readonly APPLIANCE_CATEGORIES = "appliance-categories";
	static readonly SEARCH_PARAMETER = "search-parameter";
	static readonly PROVIDER_TEAM_MEMBERS = "team-members";
	static readonly CREATE_PRODUCT = "products/create";
	static readonly EDIT_PRODUCT = "products/edit/";
	static readonly PROVIDER_ADD_TEAM_MEMBER = "team-members/add";
	static readonly LOAN_PRODUCTS = "loan-products";
	static readonly LOAN_REQUEST = "loan-request";
	static readonly LOAN_SUMMARY = "loan-summary";
	static readonly PAYMENTS = "payments";
	static readonly ROOF_TYPE = "roof-type";

	static readonly CUSTOMER_SIGNUP = "signup";
	static readonly CUSTOMER_SIGNIN = "signin";
	static readonly CUSTOMER_BASE = "";
	static readonly CUSTOMER_ORDERS = "orders";
	static readonly PASSCODE_SIGNIN = "passcode-signin";
	static readonly CUSTOMER_GET_SOLAR = "get-solar";
	static readonly LEADS = "leads";
	static readonly REQUEST = "requests";
	static readonly CUSTOMER_FORGOT_PASSWORD = "forgot-password";
	static readonly CUSTOMER_RESET_SUCCESS = "reset-success";
	static readonly CUSTOMER_TRANSACTION_HISTORY = "history";
	static readonly CUSTOMER_SUPPORT_PAGE = "support";
	static readonly CUSTOMER_CALL_CENTER = "call-center";
	static readonly CUSTOMER_TRANSACTION_HISTORY_FILTER = "history/filter";
	static readonly CUSTOMER_TRANSACTION_HISTORY_DETAIL = "history/:reference";

	static readonly NEW_CUSTOMER_SIGNUP_USER_INFORMATION = "signup/user-information";
	static readonly NEW_CUSTOMER_SIGNUP_OTP = "signup/otp";
	static readonly NEW_CUSTOMER_SIGNUP_NEXT_STEP = "signup/next-step";

	static readonly CUSTOMER_NEXT_STEP = "next-step";

	static readonly PROFILE_DETAILS = "profile-details";
	static readonly TEAM_MANAGEMENT = "team-management";
	static readonly INVITE_TEAM_MEMBER = "invite-team-member";
	static readonly MANAGE_TEAM_MEMBERS = "manage-team-members";
	static readonly TEAM_MEMBER_SUBMIT_DETAILS = "team-member-submit-details";
	static readonly FAMILY_MEMBER_SUBMIT_DETAILS = "family_member_submit_details";
	static readonly CUSTOMER_APPEARANCE = "appearance";
	static readonly SECURITY = "security";
	static readonly APP_INFORMATION = "app-information";
	static readonly REMOTE_TOKEN = "remote-token";
	static readonly CUSTOMER_FAQ = "faq";
	static readonly CUSTOMER_LEGAL = "legal";

	static readonly STORE_FRONT = "store";
	static readonly STORE_FRONT_CATEGORY = "store/category/:category";
	static readonly STORE_FRONT_ITEM = "store/item";
	static readonly CONFIRM_ORDER = "confirm-order";
	static readonly CHECKOUT = "checkout";
	static readonly WISHLIST = "store/wishlist";
	static readonly BILLING_INFO = "store/billing-info";
	static readonly CONFIRM_PAYMENT = "confirm-payment";
	static readonly ADMIN_LANDING = "home";
	static readonly ADMIN_BILLS = "bills";
	static readonly SETTINGS = "settings";
	static readonly PROFILE_PICTURE = "profile-picture";
	static readonly SOLAR_MARKET = "solar-market";
	static readonly VENDING_HISTORY = "vending-history";
	static readonly POSTPAID_HISTORY = "postpaid-history";
	static readonly AUDIT_LOG = "audit-log";

	// BPS admin module — pages live directly under ADMIN_BASE.
	static readonly BPS_CUSTOMER = "customer";
	static readonly BPS_UTILITY_SETUP = "utility-setup";
	static readonly BPS_UTILITY_SETUP_NEW = "utility-setup/new";
	// Same page as _NEW, in edit mode. Declared after it, so "/new" still wins the match.
	static readonly BPS_UTILITY_SETUP_EDIT = "utility-setup/:id";
	static readonly BPS_PAY_AS_YOU_GO = "pay-as-you-go";
	static readonly BPS_PAYG_OPTION_1 = "pay-as-you-go/option-1";
	static readonly BPS_PAYG_OPTION_2 = "pay-as-you-go/option-2";
	static readonly BPS_ACTIVE_PAYMENT = "active-payment";
	static readonly BPS_PRODUCT_ANALYTICS = "product-analytics";

	static readonly UTIL_ADMIN_SIGNUP = "utility-users/signup";

	static readonly SERVICE_REQUEST = "service-requests";
	static readonly WORKFLOWS_MANAGMENT = "workflows-managment";
	static readonly NEW = "new";
	static readonly CUSTOM_FORM = "custom-form";
	static readonly PAYMENT_OPTION = "payment-option";
	static readonly EDIT = "edit";
	static readonly INSTANCES = "instances";
	static readonly ALL_INSTANCES = "all-instances";
	static readonly BULK_PURCHASE = "bulk-purchase";
	static readonly BULK_PURCHASE_DETAILS = "bulk-purchase/details/:reference";
	static readonly WELCOME_SCREEN = "welcome-screen";
	static readonly BUY_ELECTRICITY = "buy-electricity";
	static readonly CUSTOMER_BULK_PURCHASE = "bulk-purchase";
	static readonly TRANSFER_UNIT = "transfer-unit";
	static readonly TRANSFER_UNIT_VERIFY = "transfer-unit/verify";
	static readonly TRANSFER_UNIT_RECIPIENT = "transfer-unit/recipient";
	static readonly TRANSFER_UNIT_AMOUNT = "transfer-unit/amount";

	static readonly CUSTOM_STEPS = "custom-steps";
	static readonly STEP_INSTANCE = "step-instance";
	static readonly STEPS = "steps";

	static readonly CUSTOMER_SOLAR_CONSUMPTION = "solar-consumption";
	static readonly CUSTOMER_ESTIMATED_BILL = "estimated-bill";
	static readonly CUSTOMER_SOLAR_JOURNEY = "solar-journey/:orderId";
	static readonly CUSTOMER_NOTIFICATIONS = "notifications";
	static readonly CUSTOMER_NOTIFICATION_DETAIL = "notifications/:id";

	static readonly CUSTOMER_ENERGY_MANAGEMENT = "energy-management";
	static readonly CUSTOMER_UNIT_THRESHOLD_SETUP = "unit-threshold-setup";
	static readonly CUSTOMER_CONSUMPTION_ANALYTICS = "analytics";
	static readonly CUSTOMER_SERVICE_REQUEST_DETAIL = "service-request/:id";
	static readonly CUSTOMER_SERVICE_REQUEST_PAYMENT = "service-request-payment";
	static readonly CUSTOMER_SERVICE_REQUEST_CREATE = "service-request/create";
	static readonly CUSTOMER_ALL_SERVICE_REQUESTS = "service-request/all";

	// Module-based navigation routes
	static readonly BILLS_OPERATIONS = "bills-operations";
	static readonly SERVICE_REQUEST_MODULE = "service-request";
	static readonly ACTIVITY_LOG = "activity-log";
	static readonly CUSTOMER_SUPPORT = "customer-support";
	static readonly CLIENT_MANAGEMENT = "client-management";
	static readonly REPORT_SERVICE_REQUEST = "report";
	static readonly TRACK_SERVICE_REQUEST = "track";
	static readonly CUSTOMER_360 = "customer-360";
	static readonly RECONCILLIATION = "reconcilliation";
	static readonly REFUNDS = "refunds";
	static readonly REFUND_DETAILS = "refunds/:transactionId";

	// Client Management sub-pages
	static readonly CUSTOMER_PROFILE = "customer-profile";
	static readonly METERS_ACCOUNTS = "meters-accounts";
	static readonly BILLING_HISTORY = "billing-history";
	static readonly SERVICE_REQUEST_HISTORY = "service-request-history";
	static readonly INTERACTION_LOGS = "interaction-logs";

	//referral system
	static readonly REFERAL_SYSTEM = "referral-system";
	static readonly STAFF_DETAILS = "referral-system/:id";

	static readonly CUSTOMER_WALLET = "wallet";
	static readonly CUSTOMER_WALLET_HISTORY = "wallet/history";


	// Energy Profile
	static readonly CUSTOMER_ENERGY_PROFILE = "energy-profile";
	static readonly CUSTOMER_MANAGE_METERS = "manage-meters";
	static readonly ENERGY_PROFILE_WELCOME = "energy-profile-welcome";
	static readonly ENERGY_PROFILE_CREATE = "energy-profile-create";
	static readonly ENERGY_PROFILE_NIN = "energy-profile-nin";
	static readonly SWITCH_METER_NUMBER = "switch-meter-number";
	static readonly ADD_METER = "add-meter";

	static readonly CUSTOMER_ACCOUNT_ACTIVITIES = "account-activities";
	static readonly CUSTOMER_ACCOUNT_ACTIVITIES_NIN = "account-activities/nin-verification";
	static readonly CUSTOMER_HISTORICAL_PAYMENT = "historical-payment";
	static readonly CUSTOMER_HISTORICAL_PAYMENT_DETAIL = "historical-payment/:reference";
	static readonly CUSTOMER_HISTORICAL_PAYMENT_FILTER = "historical-payment/filter";

	static readonly CUSTOMER_SAVED_BENEFICIARIES = "saved-beneficiaries";
	static readonly CUSTOMER_SAVED_BENEFICIARIES_ADD = "saved-beneficiaries/add";
	static readonly CUSTOMER_SAVED_BENEFICIARIES_DETAIL = "saved-beneficiaries/:id";

	//bps admin module sub-pages
	static readonly BPS_FUNNELS = "funnels";
	static readonly BPS_RETENTION = "retention";
	static readonly BPS_ENERGY_MANAGEMENT = "energy-management";
}
